module.exports = __webpack_public_path__ + "img/ts.48aaa2c3.svg";